import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-video-container',
  templateUrl: './video-container.component.html',
  styleUrls: ['./video-container.component.scss'],
  standalone: false,
})
export class VideoContainerComponent implements OnInit {
  @Input() title: string;
  @Input() embedUrl: string;
  @Input() containerCss: string; // Optional container css - ex. border radius to embeded container
  @Output() sendClick = new EventEmitter<boolean>();

  constructor() {}
  // TODO: Remove ngOnInit if not needed in future review
  // eslint-disable-next-line @angular-eslint/no-empty-lifecycle-method
  ngOnInit(): void {}

  /**
   * Add native host listener to handle the onClick from the custom iframe-directive for the
   * video container's iframe.
   */
  onIframeClick(): void {
    this.sendClick.emit(true);
  }
}
